import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateItemOfferUseCase {
    invoke: (itemId: number, Image: FormData) => Promise<boolean>;
  }
  
  export class UpdateItemOffer implements UpdateItemOfferUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(itemId: number, Image: FormData){
       
        if(!itemId){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateItemOffer(itemId, Image);
        return update;
    }
  }